import { Entity, validateRequired } from '@data-client/rest';
import { AddressEntity } from './Address';
import { ISODate } from '../utils/transforms';
import { OrganizationContactEntity } from './OrganizationContact';
class OrganizationEntity extends Entity {
    constructor() {
        super(...arguments);
        this.abbreviation = null;
        this.accountManagerContact = null;
        this.billingContact = null;
        this.creationByUserId = null;
        this.creationDTTM = null;
        this.defaultAddress = null;
        this.id = 0;
        this.isTrial = false;
        this.licenseExpirationDTTM = null;
        this.licensedUsersCount = null;
        this.name = null;
        this.organizationTypeId = 0;
        this.organizationTypeName = null;
        this.organizationStatusId = null;
        this.organizationStatusName = null;
        this.technicalContact = null;
        this.totalLicenses = null;
        this.trialEndDTTM = null;
        this.trialStartDTTM = null;
        this.updatedByUserId = null;
        this.updatedDTTM = null;
        this.usersCount = null;
    }
    pk() {
        return this.id;
    }
    static validate(processedEntity) {
        return (validateRequired(processedEntity, this.defaults) ||
            super.validate(processedEntity));
    }
}
OrganizationEntity.schema = {
    accountManagerContact: OrganizationContactEntity,
    billingContact: OrganizationContactEntity,
    creationDTTM: ISODate,
    defaultAddress: AddressEntity,
    licenseExpirationDTTM: ISODate,
    technicalContact: OrganizationContactEntity,
    trialEndDTTM: ISODate,
    updatedDTTM: ISODate
};
OrganizationEntity.key = 'Organization';
export { OrganizationEntity };
